import { amApi } from "../../api/apiHelper";
import { errorAlert } from "../../function/alert";

export const dunzoQuote = (formData) => async (dispatch) => {
  try {
    let _resp = await amApi.post("/DunzoQuote", formData);
    if (_resp.status === 201) {
      return _resp.data;
    }
  } catch (err) {
    console.error(err);
    errorAlert("err");
  }
};
